import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.PAGE_BY_UUID](state) {
        return (uuid) => state[uuid];
    },
};
